import type { FeedActivity } from '@/types/customer/ActivitiesFeed'

export const getLocalizedActivityText = (
  value: FeedActivity['title'] | FeedActivity['description'] | undefined,
  locale: string
): string => {
  if (typeof value === 'string') return value.trim()
  return value?.[locale as keyof typeof value]?.trim() || value?.en?.trim() || ''
}
